export const REQUIRED_FIELDS = ['finDocType', 'reportType', 'sourceType'] as const;
export const FIELDS_NAMES = {
    finDocType: 'Financial Document Type',
    reportType: 'Report Format Type',
    sourceType: 'Source Type',
} as const;
